import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './event-card.component.scss';
var EventCard = /** @class */ (function (_super) {
    tslib_1.__extends(EventCard, _super);
    function EventCard(element) {
        return _super.call(this, element) || this;
    }
    EventCard.prototype.init = function () {
    };
    EventCard.prototype.bindEvents = function () {
    };
    return EventCard;
}(Base));
export { EventCard };



//////////////////
// WEBPACK FOOTER
// ./components/event-card/event-card.component.ts
// module id = 268
// module chunks = 0